import { useTranslation } from '@frontend/i18n';
import { DatePickerField, FormRow } from '@frontend/design-system';
import { GetRuleExceptionFormFieldProps } from '../hooks/use-create-edit-rule-exception-form';
import { ExceptionTimeRangeField } from './exception-time-range-field';

type Props = {
  getFieldProps: GetRuleExceptionFormFieldProps;
};

export const NonRecurrenceForm = ({ getFieldProps }: Props) => {
  const { t } = useTranslation('schedule-settings');

  return (
    <>
      <FormRow>
        <DatePickerField label={t('Start Date')} {...getFieldProps('startDate')} />
        <DatePickerField label={t('End Date')} {...getFieldProps('endDate')} />
      </FormRow>
      <FormRow>
        <ExceptionTimeRangeField getFieldProps={getFieldProps} />
      </FormRow>
    </>
  );
};
